export default __webpack_public_path__ + "static/media/Clan Bound Vambraces of the Mound.340775bb.jpg";